document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.s-products__slider').forEach((slider, index) => {
    const parent = slider.closest('.s-products__wrap'); 

    new Swiper(slider, {
      spaceBetween: 16,
      slidesPerView: 4,
      slidesPerGroup: 1,
      allowTouchMove: true,
      updateOnWindowResize: true,
      loop: false,
      speed: 600,
      infinite: false,
      pagination: {
        el: parent?.querySelector('.s-products__pagination'),
        type: 'progressbar',
      },
      navigation: {
        nextEl: parent?.querySelector('.s-products__next'),
        prevEl: parent?.querySelector('.s-products__prev'),
      },
      breakpoints: {
            0: {
                slidesPerView: 1,
            },
            520: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        }
    });
  });

  new Swiper('.s-category-slider__wrap', {
      spaceBetween: 20,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      allowTouchMove: true,
      updateOnWindowResize: true,
      loop: false,
      speed: 600,
      pagination: {
        el: '.s-category-slider__pagination',
        type: 'progressbar',
      },
      navigation: {
        nextEl: '.s-category-slider__next',
        prevEl: '.s-category-slider__prev',
      },
    });
});
